import { and, eq } from "drizzle-orm";
import { counterparties, priceTypes, productPrices } from "@briolin/db";
import type { TestDb } from "@briolin/db/src/testing.js";
import { PriceNotFoundError } from "./errors.js";

type Db = TestDb; // прод-БД того же типа Drizzle PgDatabase

async function priceFor(db: Db, productId: string, priceTypeId: string): Promise<number | null> {
  const [row] = await db.select({ price: productPrices.priceKopecks })
    .from(productPrices)
    .where(and(eq(productPrices.productId, productId), eq(productPrices.priceTypeId, priceTypeId)));
  return row?.price ?? null;
}

export async function resolvePrice(
  db: Db, args: { counterpartyId: string; productId: string },
): Promise<number> {
  const [cp] = await db.select().from(counterparties).where(eq(counterparties.id, args.counterpartyId));
  if (!cp) throw new PriceNotFoundError(args.productId);

  let base: number | null = null;
  if (cp.priceTypeId) base = await priceFor(db, args.productId, cp.priceTypeId);
  if (base === null) {
    const [retail] = await db.select().from(priceTypes).where(eq(priceTypes.kind, "retail"));
    if (retail) base = await priceFor(db, args.productId, retail.id);
  }
  if (base === null) throw new PriceNotFoundError(args.productId);

  const discount = Number(cp.discountPercent);
  return Math.round(base * (1 - discount / 100));
}
